import { render, staticRenderFns } from "./MegaMenuArrow.vue?vue&type=template&id=af0fa0a8&"
import script from "./MegaMenuArrow.vue?vue&type=script&lang=js&"
export * from "./MegaMenuArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports